<template>
    <section v-if="loaded" class="bng-registration hero">
        <div class="container bng-narrow-container">
            <div class="column">
                <div class="card">
                    <div class="card-content">
                        <p class="title">{{'components.pages.registration.register' | translate}}</p>
                        <div v-if="typesList.length > 1" class="tabs is-centered">
                            <ul>
                                <li
                                    v-for="typeItem of typesList"
                                    :class="{ 'is-active': registrationType == typeItem }"
                                >
                                    <a @click="registrationType = typeItem">
                                        {{"components.pages.registration.by " + typeItem | translate}}
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <by-phone
                            v-if="isPhoneRegistrationAvailable && registrationType == 'phone' && step == 1"
                            :to-step2="toStep2"
                            :branch-code="branchCode"
                        />
                        <by-phone-confirmation
                            v-if="isPhoneRegistrationAvailable && registrationType == 'phone' && step == 2"
                            :phone="phone"
                            :to-step1="toStep1"
                        />
                        <by-email
                            v-if="isEmailRegistrationAvailable && registrationType == 'email' && step == 1"
                            :to-step2="toStep2"
                            :branch-code="branchCode"
                        />
                        <by-email-confirmation
                            v-if="isEmailRegistrationAvailable && registrationType == 'email' && step == 2"
                            :email="email"
                            :to-step1="toStep1"
                        />
                        <by-login
                            v-if="isLoginRegistrationAvailable && registrationType == 'login'"
                            :branch-code="branchCode"
                        />
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Vue from 'vue';

import ymService from '../../../../../../_common/services/ym.service';
import gaService from '../../../../../../_common/services/ga.service';

import ByEmail from './by-email.vue';
import ByEmailConfirmation from './by-email-confirmation.vue';
import ByLogin from './by-login.vue';
import ByPhone from './by-phone.vue';
import ByPhoneConfirmation from './by-phone-confirmation.vue';

export default {
    name: 'registration',
    props: ['branchCode'],
    components: { ByEmail, ByEmailConfirmation, ByLogin, ByPhone, ByPhoneConfirmation },
    data() {
        return {
            loaded: false,
            client: null,
            defaultRegistrationType: null,
            registrationType: null,
            step: 1,
            phone: null,
            email: null,
            typesList: []
        };
    },
    computed: {
        isPhoneRegistrationAvailable() {
            return this.client && this.client.registration.registrationTypes.some(type => type === 'phone');
        },
        isEmailRegistrationAvailable() {
            return this.client && this.client.registration.registrationTypes.some(type => type === 'email');
        },
        isLoginRegistrationAvailable() {
            return this.client && this.client.registration.registrationTypes.some(type => type === 'login');
        }
    },
    async created() {
        // load client
        await Vue.state.client.ensure();
        this.client = Vue.state.client.get();

        // set registration type
        this.defaultRegistrationType = this.client.registration.defaultRegistrationType || this.client.registration.registrationTypes[0];
        this.registrationType = this.defaultRegistrationType;

        if (this.isPhoneRegistrationAvailable) this.typesList.push('phone');
        if (this.isEmailRegistrationAvailable) this.typesList.push('email');
        if (this.isLoginRegistrationAvailable) this.typesList.push('login');

        this.loaded = true;
    },
    mounted() {
        ymService.send('reachGoal', 'REGISTRATION STEP 1');
        gaService.send('registration', 'registrationstep1', 'registration1');
    },
    methods: {
        toStep2(data) {
            ymService.send('reachGoal', 'REGISTRATION STEP 2');
            gaService.send('registration', 'registrationstep2', 'registration2');

            this.phone = data.phone;
            this.email = data.email;
            this.step = 2;
        },
        toStep1(data) {
            this.step = 1;
        }
    }
};
</script>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/registration/registration.vue